import { format } from "date-fns";
import fileDownload from "js-file-download";

import * as OmniAwsApi from "./api/omniAws";
import * as OmniDataModel from "./omniDataModel";

//NOTE: This class is a data wrapper for convenience around the actual API implementations.
//this is a layer for us to do checks on version updates and stuff like that.
//these methods are meant to be called from the redux middle ware and not from other places
//unless you have a good reason. But thats why the Redux Middleware calls these methods and not the API directly
//
//NOTE#1: It is the responsibility of the Redux Middleware to set a new _id if needed and call the appropriate
//        Interface here (i.e. create vs. update). The redux model heavily leverages the _id for implementation.
//
//NOTE#2: This class provides a single layer of logging/error handling impementations around the raw API calls.
//        And it is where we define the standard behavior of our api (return null on failure for example)
//        It is the translator between the Redux State Machine (that drives the UI) and the raw API calls.

const defaultPageSize = 20;

//#region Administrator
export const createAdministrator = async administratorODM => {
  try {
    if (administratorODM.omniData.partnerData == null) {
      delete administratorODM.omniData.partnerData;
    }
    if (administratorODM.omniData.providerData == null) {
      delete administratorODM.omniData.providerData;
    }
    if (administratorODM.omniData.patientData == null) {
      delete administratorODM.omniData.patientData;
    }

    //all object validation should hav e been done above
    let theResult = await OmniAwsApi.awsCreateAdministrator(administratorODM);
    return OmniDataModel.validateUserODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateAdministrator = async administratorODM => {
  try {
    if (administratorODM.omniData.partnerData == null) {
      delete administratorODM.omniData.partnerData;
    }
    if (administratorODM.omniData.providerData == null) {
      delete administratorODM.omniData.providerData;
    }
    if (administratorODM.omniData.patientData == null) {
      delete administratorODM.omniData.patientData;
    }

    let theResult = await OmniAwsApi.awsUpdateAdministrator(administratorODM);
    return OmniDataModel.validateUserODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteAdministrator = async administratorId => {
  try {
    let theResult = await OmniAwsApi.awsDeleteAdministrator(administratorId);
    if (theResult == null) {
      // success
      return administratorId;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAdministrator = async administratorId => {
  try {
    let theResult = await OmniAwsApi.awsGetAdministrator(administratorId);
    return OmniDataModel.validateUserODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllAdministrators = async (page, includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetAdministrators(page, defaultPageSize, includeInactive);

      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateUserODM(theResult.items[i]));
      }

      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};
//#endregion

//#region Assessment
export const createAssessment = async assessmentODM => {
  try {
    let theResult = await OmniAwsApi.awsCreateAssessment(assessmentODM);
    return OmniDataModel.validateAssessmentODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateAssessment = async assessmentODM => {
  try {
    let theResult = await OmniAwsApi.awsUpdateAssessment(assessmentODM);

    return OmniDataModel.validateAssessmentODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteAssessment = async assessmentId => {
  try {
    let theResult = await OmniAwsApi.awsDeleteAssessment(assessmentId);

    if (theResult == null) {
      // successcreateAdministrator
      return assessmentId;
      //  return OmniDataModel.validateAssessmentODM(theResult);
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAssessment = async assessmentId => {
  try {
    let theResult = await OmniAwsApi.awsGetAssessment(assessmentId);
    return OmniDataModel.validateAssessmentODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllAssessments = async (includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetAssessments(page, defaultPageSize, includeInactive);
      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateAssessmentODM(theResult.items[i]));
      }

      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAssessmentsByOmniType = async (omniType, includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetAssessments(page, defaultPageSize, includeInactive);
      for (let i = 0; i < theResult.items.length; ++i) {
        if (theResult.items[i].omniData.omniType === omniType) {
          theReturn.push(OmniDataModel.validateAssessmentODM(theResult.items[i]));
        }
      }

      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllAssessmentByRelatedID = async (relatedId, includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetAssessmentsBy(
        relatedId,
        page,
        defaultPageSize,
        includeInactive,
      );

      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateAssessmentODM(theResult.items[i]));
      }
      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const searchAssessments = async (pagination, includeInactive = false) => {
  try {
    let theReturn = [];

    let theResult = await OmniAwsApi.awsSearchAssessments(
      pagination.query,
      pagination.sort,
      pagination.pageIndex,
      pagination.pageSize,
      includeInactive,
    );

    for (let i = 0; i < theResult.items.length; ++i) {
      theReturn.push(OmniDataModel.validateAssessmentODM(theResult.items[i]));
    }

    theResult.items = theReturn;

    return theResult;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion

//#region ConversationConfiguration
export const createConversationConfiguration = async conversationConfigurationODM => {
  try {
    let theResult = await OmniAwsApi.awsCreateConversationConfiguration(
      conversationConfigurationODM,
    );
    return OmniDataModel.validateConversationConfigurationODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateConversationConfiguration = async conversationConfigurationODM => {
  try {
    let theResult = await OmniAwsApi.awsUpdateConversationConfiguration(
      conversationConfigurationODM,
    );

    return OmniDataModel.validateConversationConfigurationODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteConversationConfiguration = async conversationConfigurationId => {
  try {
    let theResult = await OmniAwsApi.awsDeleteConversationConfiguration(
      conversationConfigurationId,
    );
    if (theResult == null) {
      // success
      return conversationConfigurationId;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getConversationConfiguration = async conversationConfigurationId => {
  try {
    let theResult = await OmniAwsApi.awsGetConversationConfiguration(conversationConfigurationId);
    return OmniDataModel.validateConversationConfigurationODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllConversationConfigurations = async (
  practiceId = null,
  includeInactive = false,
) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetConversationConfigurations(
        page,
        defaultPageSize,
        includeInactive,
      );
      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateConversationConfigurationODM(theResult.items[i]));
      }
      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion

//#region Invite
export const createInvite = async invitationODM => {
  try {
    let theResult = await OmniAwsApi.awsCreateInvite(invitationODM);

    return OmniDataModel.validateInviteODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateInvite = async invitationODM => {
  try {
    let theResult = await OmniAwsApi.awsUpdateInvite(invitationODM);

    return OmniDataModel.validateInviteODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteInvite = async inviteID => {
  try {
    let theResult = await OmniAwsApi.awsDeleteInvite(inviteID);

    if (theResult != null) {
      // success
      return inviteID;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getInvite = async inviteID => {
  try {
    let theResult = await OmniAwsApi.awsGetInvite(inviteID);
    return OmniDataModel.validateInviteODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllInvites = async (includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetInvites(page, defaultPageSize, includeInactive);
      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateInviteODM(theResult.items[i]));
      }
      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllInvitesByRelatedId = async (relatedId, includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetInvitesBy(
        relatedId,
        page,
        defaultPageSize,
        includeInactive,
      );
      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateInviteODM(theResult.items[i]));
      }
      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const searchInvites = async (pagination, includeInactive = false) => {
  try {
    let theReturn = [];

    let theResult = await OmniAwsApi.awsSearchInvites(
      pagination.query,
      pagination.sort,
      pagination.pageIndex,
      pagination.pageSize,
      includeInactive,
    );

    for (let i = 0; i < theResult.items.length; ++i) {
      theReturn.push(OmniDataModel.validateInviteODM(theResult.items[i]));
    }

    theResult.items = theReturn;

    return theResult;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createBulkInvites = async inviteODMs => {
  try {
    let theResult = await OmniAwsApi.awsCreateBulkInvites(inviteODMs);
    //todo find!ak how to validate this?
    return theResult;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteBulkInvites = async inviteQueryODM => {
  try {
    let theResult = await OmniAwsApi.awsDeleteBulkInvites(inviteQueryODM);
    //todo find!ak how to validate this?
    return theResult;
  } catch (error) {
    console.log(error);
    return null;
  }
};
//#endregion

//#region Motivation
export const createMotivation = async motivationODM => {
  try {
    let theResult = await OmniAwsApi.awsCreateMotivation(motivationODM);
    return OmniDataModel.validateMotivationODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateMotivation = async motivationODM => {
  try {
    let theResult = await OmniAwsApi.awsUpdateMotivation(motivationODM);

    return OmniDataModel.validateMotivationODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteMotivation = async motivationId => {
  try {
    let theResult = await OmniAwsApi.awsDeleteMotivation(motivationId);

    if (theResult != null) {
      // success
      return motivationId;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getMotivation = async motivationId => {
  try {
    let theResult = await OmniAwsApi.awsGetMotivation(motivationId);
    return OmniDataModel.validateMotivationODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllMotivations = async (userID = null, includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetMotivations(page, defaultPageSize, includeInactive);
      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateMotivationODM(theResult.items[i]));
      }
      page++;
    } while (theResult.pageInfo.itemCount === defaultPageSize);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion

//#region Onboarding
export const onboardPatient = async onboardingODM => {
  try {
    let tmpUser = {
      omniData: onboardingODM.omniData.userData,
      omniRelationships: { relatedData: [] },
    };

    const defaultValues = OmniDataModel.createNewUser(true, false, false, false);
    tmpUser.omniData["patientData"] = defaultValues.omniData.patientData;

    let requestParams = {
      credentials: onboardingODM.omniData.credentials,
      user: tmpUser,
    };

    let theResult = await OmniAwsApi.awsOnboardPatient(
      requestParams,
      onboardingODM.omniData.inviteKey,
    );
    return theResult;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const onboardPartner = async onboardingODM => {
  try {
    let tmpUser = {
      omniData: onboardingODM.omniData.userData,
      omniRelationships: { relatedData: [] },
    };

    const defaultValues = OmniDataModel.createNewUser(false, false, true, false);
    tmpUser.omniData["partnerData"] = defaultValues.omniData.partnerData;

    let requestParams = {
      credentials: onboardingODM.omniData.credentials,
      user: tmpUser,
    };

    let theResult = await OmniAwsApi.awsOnboardPartner(
      requestParams,
      onboardingODM.omniData.inviteKey,
    );
    return theResult;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const onboardProvider = async onboardingODM => {
  try {
    let tmpUser = {
      omniData: onboardingODM.omniData.userData,
      omniRelationships: { relatedData: [] },
    };

    const defaultValues = OmniDataModel.createNewUser(false, true, false, false);
    tmpUser.omniData["providerData"] = defaultValues.omniData.providerData;

    tmpUser.omniData["providerData"]["afterHoursContact"] = { name: "", phoneNumber: "" };

    let requestParams = {
      credentials: onboardingODM.omniData.credentials,
      user: tmpUser,
    };

    let theResult = await OmniAwsApi.awsOnboardProvider(
      requestParams,
      onboardingODM.omniData.inviteKey,
    );

    return theResult;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const onboardAdministrator = async onboardingODM => {
  try {
    let tmpUser = {
      omniData: onboardingODM.omniData.userData,
      omniRelationships: { relatedData: [] },
    };

    const defaultValues = OmniDataModel.createNewUser(false, false, false, true);
    tmpUser.omniData["administratorData"] = defaultValues.omniData.administratorData;

    let requestParams = {
      credentials: onboardingODM.omniData.credentials,
      user: tmpUser,
    };

    let theResult = await OmniAwsApi.awsOnboardAdministrator(
      requestParams,
      onboardingODM.omniData.inviteKey,
    );

    return theResult;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const getOnboarding = async onboardingId => {
  try {
    let theResult = await OmniAwsApi.awsGetOnboarding(onboardingId);
    if (theResult.hasOwnProperty("omniData")) {
      return OmniDataModel.validateOnboardingODM(theResult);
    } else {
      return theResult;
    }
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const unsubscribeUser = async inviteId => {
  try {
    // let tmpUser = {
    //   omniData: onboardingODM.omniData.userData,
    //   omniRelationships: { relatedData: [] },
    // };

    // const defaultValues = OmniDataModel.createNewUser(false, false, false, true);
    // tmpUser.omniData["administratorData"] = defaultValues.omniData.administratorData;

    // let requestParams = {
    //   credentials: onboardingODM.omniData.credentials,
    //   user: tmpUser,
    // };

    let theResult = await OmniAwsApi.awsUnsubscribeUser(inviteId);

    return theResult;
  } catch (error) {
    console.log(error);
    return error;
  }
};
//#endregion

//#region Organization
export const createOrganization = async organizationODM => {
  try {
    let theResult = await OmniAwsApi.awsCreateOrganization(organizationODM);
    return OmniDataModel.validateOrganizationODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateOrganization = async organizationODM => {
  try {
    delete organizationODM.omniData.communications; //find!ak

    let theResult = await OmniAwsApi.awsUpdateOrganization(organizationODM);
    return OmniDataModel.validateOrganizationODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteOrganization = async organizationId => {
  try {
    let theResult = await OmniAwsApi.awsDeleteOrganization(organizationId);

    if (theResult != null) {
      return organizationId;
    }
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getOrganization = async organizationId => {
  try {
    let theResult = await OmniAwsApi.awsGetOrganization(organizationId);

    // if (theResult.omniData.defaultAsssesmentType === "omniMSSOnboard") {
    //   theResult.omniData.defaultAsssesmentType = "omniMSOnboard";
    // }

    return OmniDataModel.validateOrganizationODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllOrganizations = async (includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetOrganizations(page, defaultPageSize, includeInactive);

      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateOrganizationODM(theResult.items[i]));
      }
      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion

//#region Partner
export const createPartner = async partnerODM => {
  try {
    if (partnerODM.omniData.patientData == null) {
      delete partnerODM.omniData.patientData;
    }
    if (partnerODM.omniData.providerData == null) {
      delete partnerODM.omniData.providerData;
    }

    let theResult = await OmniAwsApi.awsCreatePartner(partnerODM);
    return OmniDataModel.validateUserODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updatePartner = async partnerODM => {
  try {
    if (partnerODM.omniData.patientData == null) {
      delete partnerODM.omniData.patientData;
    }
    if (partnerODM.omniData.providerData == null) {
      delete partnerODM.omniData.providerData;
    }

    let theResult = await OmniAwsApi.awsUpdatePartner(partnerODM);
    return OmniDataModel.validateUserODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deletePartner = async partnerId => {
  try {
    let theResult = await OmniAwsApi.awsDeletePartner(partnerId);
    if (theResult != null) {
      // success
      return partnerId;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getPartner = async partnerId => {
  try {
    let theResult = await OmniAwsApi.awsGetPartner(partnerId);
    return OmniDataModel.validateUserODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllPartners = async (includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetPartners(page, defaultPageSize, includeInactive);

      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateUserODM(theResult.items[i]));
      }
      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const searchPartners = async (pagination, includeInactive = false) => {
  try {
    let theReturn = [];

    let theResult = await OmniAwsApi.awsSearchPartners(
      pagination.query,
      pagination.sort,
      pagination.pageIndex,
      pagination.pageSize,
      includeInactive,
    );

    for (let i = 0; i < theResult.items.length; ++i) {
      theReturn.push(OmniDataModel.validateUserODM(theResult.items[i]));
    }

    theResult.items = theReturn;

    return theResult;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion

//#region Patient
export const createPatient = async patientODM => {
  try {
    //
    if (patientODM.omniData.partnerData == null) {
      delete patientODM.omniData.partnerData;
    }
    if (patientODM.omniData.providerData == null) {
      delete patientODM.omniData.providerData;
    }
    if (patientODM.omniData.administratorData == null) {
      delete patientODM.omniData.administratorData;
    }

    if (!patientODM.omniData.email) {
      delete patientODM.omniData.email;
    }

    if (!patientODM.omniData.mobilePhone) {
      delete patientODM.omniData.mobilePhone;
    }

    //all object validation should hav e been done above
    let theResult = await OmniAwsApi.awsCreatePatient(patientODM);

    return OmniDataModel.validateUserODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updatePatient = async patientODM => {
  try {
    if (patientODM.omniData.partnerData == null) {
      delete patientODM.omniData.partnerData;
    }
    if (patientODM.omniData.providerData == null) {
      delete patientODM.omniData.providerData;
    }
    if (patientODM.omniData.administratorData == null) {
      delete patientODM.omniData.administratorData;
    }

    if (!patientODM.omniData.email) {
      delete patientODM.omniData.email;
    }

    if (!patientODM.omniData.mobilePhone) {
      delete patientODM.omniData.mobilePhone;
    }

    let theResult = await OmniAwsApi.awsUpdatePatient(patientODM);
    return OmniDataModel.validateUserODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deletePatient = async patientId => {
  try {
    let theResult = await OmniAwsApi.awsDeletePatient(patientId);
    if (theResult != null) {
      // success
      return patientId;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getPatient = async patientId => {
  try {
    let theResult = await OmniAwsApi.awsGetPatient(patientId);
    return OmniDataModel.validateUserODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getPatients = async (page = 1, includeInactive = false) => {
  try {
    let theReturn = [];
    let theResult = null;

    theResult = await OmniAwsApi.awsGetPatients(page, defaultPageSize, includeInactive);

    for (let i = 0; i < theResult.items.length; ++i) {
      theReturn.push(OmniDataModel.validateUserODM(theResult.items[i]));
    }

    theResult.items = theReturn;

    return theResult;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllPatientsByRelatedId = async (relatedId, includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetPatientsBy(
        relatedId,
        page,
        defaultPageSize,
        includeInactive,
      );
      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateUserODM(theResult.items[i]));
      }
      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const searchPatients = async (pagination, includeInactive = false) => {
  try {
    let theReturn = [];

    let theResult = await OmniAwsApi.awsSearchPatients(
      pagination.query,
      pagination.sort,
      pagination.pageIndex,
      pagination.pageSize,
      includeInactive,
    );

    for (let i = 0; i < theResult.items.length; ++i) {
      theReturn.push(OmniDataModel.validateUserODM(theResult.items[i]));
    }

    theResult.items = theReturn;

    return theResult;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion

//#region Practice
export const createPractice = async practiceODM => {
  try {
    practiceODM.omniData.businessHours = Object.fromEntries(
      Object.entries(practiceODM.omniData.businessHours).filter(([_, v]) => v != null),
    );

    let theResult = await OmniAwsApi.awsCreatePractice(practiceODM);
    return OmniDataModel.validatePracticeODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updatePractice = async practiceODM => {
  try {
    practiceODM.omniData.businessHours = Object.fromEntries(
      Object.entries(practiceODM.omniData.businessHours).filter(([_, v]) => v != null),
    );

    let theResult = await OmniAwsApi.awsUpdatePractice(practiceODM);
    return OmniDataModel.validatePracticeODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deletePractice = async practiceId => {
  try {
    let theResult = await OmniAwsApi.awsDeletePractice(practiceId);

    if (theResult != null) {
      // success
      return practiceId;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getPractice = async practiceId => {
  try {
    let theResult = await OmniAwsApi.awsGetPractice(practiceId);
    return OmniDataModel.validatePracticeODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllPractices = async (includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetPractices(page, defaultPageSize, includeInactive);

      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validatePracticeODM(theResult.items[i]));
      }
      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion

//#region Provider
export const createProvider = async providerODM => {
  try {
    if (providerODM.omniData.partnerData == null) {
      delete providerODM.omniData.partnerData;
    }
    if (providerODM.omniData.patientData == null) {
      delete providerODM.omniData.patientData;
    }

    let theResult = await OmniAwsApi.awsCreateProvider(providerODM);
    return OmniDataModel.validateUserODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateProvider = async providerODM => {
  try {
    if (providerODM.omniData.partnerData == null) {
      delete providerODM.omniData.partnerData;
    }
    if (providerODM.omniData.patientData == null) {
      delete providerODM.omniData.patientData;
    }

    let theResult = await OmniAwsApi.awsUpdateProvider(providerODM);
    return OmniDataModel.validateUserODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteProvider = async providerId => {
  try {
    let theResult = await OmniAwsApi.awsDeleteProvider(providerId);
    if (theResult != null) {
      // success
      return providerId;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getProvider = async providerId => {
  try {
    let theResult = await OmniAwsApi.awsGetProvider(providerId);
    return OmniDataModel.validateUserODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllProviders = async (includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetProviders(page, defaultPageSize, includeInactive);

      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateUserODM(theResult.items[i]));
      }

      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const searchProviders = async (pagination, includeInactive = false) => {
  try {
    let theReturn = [];

    let theResult = await OmniAwsApi.awsSearchProviders(
      pagination.query,
      pagination.sort,
      pagination.pageIndex,
      pagination.pageSize,
      includeInactive,
    );

    for (let i = 0; i < theResult.items.length; ++i) {
      theReturn.push(OmniDataModel.validateUserODM(theResult.items[i]));
    }

    theResult.items = theReturn;

    return theResult;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion

//#region Exports

export const exportAssessedPatients = async (assessmentType, includeInactive = false) => {
  try {
    //Unique ID
    let onlyFields = "_id";
    //Audit Fields
    onlyFields += ",omniAudit.modifiedDate,omniAudit.createdDate,omniAudit.isActive";
    //UserData - Name
    onlyFields +=
      ",omniData.displayName,omniData.nameTitle,omniData.givenName,omniData.middleName,omniData.familyName,omniData.nameSuffix";
    //UserData - Contact
    onlyFields += ",omniData.mobilePhone,omniData.email,omniData.preferredAlertMethod";
    //UserData - Demographics
    onlyFields += ",omniData.birthdate,omniData.gender,omniData.race,omniData.ethnicity";

    //address
    onlyFields +=
      ",omniData.address.streetAddress,omniData.address.locality,omniData.address.region,omniData.address.postalCode,omniData.address.country";
    //Patient Data
    let patientData = OmniDataModel.createNewPatientData();
    for (var prop in patientData) {
      if (Object.prototype.hasOwnProperty.call(patientData, prop)) {
        onlyFields += `,omniData.patientData.${prop}`;
      }
    }

    let theResult = await OmniAwsApi.awsReportAssessedPatients(
      assessmentType,
      onlyFields,
      includeInactive,
    );

    fileDownload(
      theResult,
      `${assessmentType}_Candidate_Export_${format(new Date(), "yyMMdd_hhmmss")}.csv`,
    );

    return true;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion

//#region Reports
export const createReport = async reportODM => {
  try {
    let theResult = await OmniAwsApi.awsCreateReport(reportODM);

    return OmniDataModel.validateReportODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteReport = async reportID => {
  try {
    let theResult = await OmniAwsApi.awsDeleteReport(reportID);

    if (theResult != null) {
      // success
      return reportID;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getReport = async reportID => {
  try {
    let theResult = await OmniAwsApi.awsGetReport(reportID);
    return OmniDataModel.validateReportODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllReports = async (includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetReports(page, defaultPageSize, includeInactive);
      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateReportODM(theResult.items[i]));
      }
      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const searchReports = async (pagination, includeInactive = false) => {
  try {
    let theReturn = [];

    let theResult = await OmniAwsApi.awsSearchReports(
      pagination.query,
      pagination.sort,
      pagination.pageIndex,
      pagination.pageSize,
      includeInactive,
    );

    for (let i = 0; i < theResult.items.length; ++i) {
      theReturn.push(OmniDataModel.validateUserODM(theResult.items[i]));
    }

    theResult.items = theReturn;

    return theResult;
  } catch (error) {
    console.log(error);
    return null;
  }
};
//#endregion

//#region CommunicationRequest
export const createCommunicationRequest = async invitationODM => {
  try {
    let theResult = await OmniAwsApi.awsCreateCommunicationRequest(invitationODM);

    return OmniDataModel.validateCommunicationRequestODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateCommunicationRequest = async communicationRequestODM => {
  try {
    let theResult = await OmniAwsApi.awsUpdateCommunicationRequest(communicationRequestODM);
    return OmniDataModel.validateCommunicationRequestODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteCommunicationRequest = async partnerId => {
  try {
    let theResult = await OmniAwsApi.awsDeleteCommunicationRequest(partnerId);

    if (theResult != null) {
      // success
      return partnerId;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getCommunicationRequest = async partnerId => {
  try {
    let theResult = await OmniAwsApi.awsGetCommunicationRequest(partnerId);
    return OmniDataModel.validateCommunicationRequestODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllCommunicationRequests = async (includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetCommunicationRequests(
        page,
        defaultPageSize,
        includeInactive,
      );

      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateCommunicationRequestODM(theResult.items[i]));
      }
      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const searchCommunicationRequests = async (pagination, includeInactive = false) => {
  try {
    let theReturn = [];

    let theResult = await OmniAwsApi.awsSearchCommunicationRequests(
      pagination.query,
      pagination.sort,
      pagination.pageIndex,
      pagination.pageSize,
      includeInactive,
    );

    for (let i = 0; i < theResult.items.length; ++i) {
      theReturn.push(OmniDataModel.validateCommunicationRequestODM(theResult.items[i]));
    }

    theResult.items = theReturn;

    return theResult;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion

//#region CommunicationTemplate
export const createCommunicationTemplate = async communicationTemplateODM => {
  try {
    let theResult = await OmniAwsApi.awsCreateCommunicationTemplate(communicationTemplateODM);

    return OmniDataModel.validateCommunicationTemplateODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const updateCommunicationTemplate = async communicationRequestODM => {
  try {
    let theResult = await OmniAwsApi.awsUpdateCommunicationTemplate(communicationRequestODM);
    return OmniDataModel.validateCommunicationTemplateODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const deleteCommunicationTemplate = async partnerId => {
  try {
    let theResult = await OmniAwsApi.awsDeleteCommunicationTemplate(partnerId);
    if (theResult != null) {
      // success
      return partnerId;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getCommunicationTemplate = async templateID => {
  try {
    let theResult = await OmniAwsApi.awsGetCommunicationTemplate(templateID);
    return OmniDataModel.validateCommunicationTemplateODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getAllCommunicationTemplates = async (includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsGetCommunicationTemplates(
        page,
        defaultPageSize,
        includeInactive,
      );

      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateCommunicationTemplateODM(theResult.items[i]));
      }
      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const searchCommunicationTemplates = async (queryODM, includeInactive = false) => {
  try {
    let page = 1;
    let theReturn = [];
    let theResult = null;

    do {
      theResult = await OmniAwsApi.awsSearchCommunicationTemplates(
        queryODM,
        page,
        defaultPageSize,
        includeInactive,
      );

      for (let i = 0; i < theResult.items.length; ++i) {
        theReturn.push(OmniDataModel.validateCommunicationTemplateODM(theResult.items[i]));
      }

      page++;
    } while (theReturn.length < theResult.pageInfo.itemCount);

    return theReturn;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion

//#region CommunicationTemplate
export const prosecuteCampaign = async communicationTemplateId => {
  try {
    let theResult = await OmniAwsApi.awsProsecuteCampaign(communicationTemplateId);

    return theResult;
    // return OmniDataModel.validateCommunicationTemplateODM(theResult);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getCampaign = async campaignID => {
  try {
    let theResult = await OmniAwsApi.awsGetCampaign(campaignID);
    // return OmniDataModel.validateCommunicationTemplateODM(theResult);
    return theResult;
  } catch (error) {
    console.log(error);
    return null;
  }
};

//#endregion

export const sendEmailCommunication = async queryODM => {
  try {
    let theResult = await OmniAwsApi.awsSendEmailCommunication(queryODM);
    if (theResult != null) {
      return `Email Send Success: ${theResult}`;
    }
    return "Email Send Failed";
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const healthCheck = async () => {
  try {
    let theResult = await OmniAwsApi.awsHealthCheck();
    if (theResult != null) {
      return `Health Check Success: ${theResult}`;
    }
    return "Health Check Failed";
  } catch (error) {
    console.log(error);
    return null;
  }
};
